import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  loader: () => {
    throw redirect({
      params: {
        asset: 'BTC',
      },
      replace: true,
      to: '/trade/$asset',
    });
  },
});
